import React, { useState } from 'react';
import { Button } from '../ui/button';
import { FilePenLine, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';

export const OFFICE_TYPES = ['docx', 'xlsx'];

export const isOfficeFile = (fileType) => OFFICE_TYPES.includes((fileType || '').toLowerCase());

export const OfficeEditButton = ({ source, id, fileType, onReturn, className = '', label, testId }) => {
  const [busy, setBusy] = useState(false);
  if (!isOfficeFile(fileType)) return null;
  const appName = fileType.toLowerCase() === 'xlsx' ? 'Excel' : 'Word';

  const open = async () => {
    setBusy(true);
    try {
      const { data } = await api.post('/office-edit/sessions', { source, id });
      const scheme = data.app === 'excel' ? 'ms-excel' : 'ms-word';
      const base = process.env.REACT_APP_BACKEND_URL;
      const url = `${base}/api/dav/${data.token}/${encodeURIComponent(data.filename)}`;
      window.location.href = `${scheme}:ofe|u|${url}`;
      toast.success(`${appName} wird geöffnet …`, {
        description: 'Mit Strg+S speichern – jede Speicherung wird als neue Version abgelegt. Öffnet sich nichts, ist Office auf diesem Gerät nicht installiert.',
        duration: 9000,
      });
      if (onReturn) window.addEventListener('focus', () => setTimeout(onReturn, 800), { once: true });
    } catch (e) {
      toast.error((typeof e.response?.data?.detail === 'string' && e.response.data.detail) || `${appName} konnte nicht geöffnet werden`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button type="button" variant={label ? 'outline' : 'ghost'} size={label ? 'sm' : 'icon'}
      className={`${label ? 'rounded-full' : 'h-8 w-8 rounded-full'} text-blue-700 ${className}`}
      onClick={open} disabled={busy} title={`In ${appName} bearbeiten`}
      data-testid={testId || `office-edit-${source}-${id}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FilePenLine className="h-4 w-4" />}
      {label && <span className="ml-1">{label}</span>}
    </Button>
  );
};
